import React from "react";
import { DownloadIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
export function FinalCta() {
  return <section id="cierre" className="bg-ink py-20 text-cream md:py-32" aria-labelledby="final-title" data-id="element-118" data-mp="vghfhjugu3md">
      <div className="mx-auto max-w-3xl px-5 text-center md:px-8" data-id="element-119" data-mp="19giip5y7dn50">
        <h2 id="final-title" className="font-display text-[2.1rem] font-semibold leading-[1.1] sm:text-5xl md:text-6xl" data-id="element-120" data-mp="15d42ae6cr4r1">
          Empezá hoy a construir tu propio negocio de limpieza.
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-cream/80" data-id="element-121" data-mp="1ed8uvi6vzyl5">
          Dejá de depender de que alguien te dé trabajo. Con el ebook, los 8 bonos y el kit en el celular tenés un
          plan para dar tus primeros pasos.
        </p>
        <div className="mt-10 flex flex-col items-stretch gap-4 sm:items-center" data-id="element-122" data-mp="223cznsvta4dq">
          <CtaButton data-id="element-123" data-mp="221a46tbw3j1m">Quiero empezar hoy</CtaButton>
          <a href="#oferta" className="py-2 text-sm font-semibold text-cream underline decoration-sun decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-sun" data-id="element-124" data-mp="1x5upjz625j45">
            Ver qué incluye y el precio
          </a>
        </div>
        <p className="mt-4 flex items-center justify-center gap-2 text-sm text-cream/65" data-id="element-125" data-mp="x2qt848we3jq">
          <DownloadIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-126" data-mp="12352fpm8jjjc" />
          Compra única · Acceso digital por descarga
        </p>
      </div>
    </section>;
}